


import { FaTimes, FaUserCircle } from 'react-icons/fa';

export default function ProfileModal({ user, onClose }) {
  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="fixed top-1/2 left-1/2 z-50 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 border-t-4 border-primary">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-primary">Your Profile</h2>
          <button onClick={onClose} className="hover:text-red-500 transition duration-200">
            <FaTimes className="text-xl" />
          </button>
        </div>

        {/* Profile Icon */}
        <div className="flex justify-center mb-4">
          <FaUserCircle className="text-6xl text-primary" />
        </div>

        <hr className="mb-4" />

        {/* Profile Details */}
        <div className="space-y-4 text-gray-700">
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">First Name</p>
            <p className="text-lg font-medium">{user.firstName}</p>
          </div>
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Last Name</p>
            <p className="text-lg font-medium">{user.lastName}</p>
          </div>
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Email</p>
            <p className="text-lg font-medium">{user.email}</p>
          </div>
        </div>
      </div>
    </>
  );
}
